import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuotesComponent } from './quotes.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { GeneralInformationsComponent } from './components/general-information/general-information.component';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { QuotationFormComponent } from './components/quotation-form/quotation-form.component';
import { FormModule } from '@spartacus/organization/administration/components';
import { quotesOccContentConfig } from './core/quotes.occ';
import { ProductFinderComponent } from './components/product-finder/product-finder.component';
import { BasicSearchComponent } from './components/product-finder/basic-search/basic-search.component';
import { AdvancedSearchComponent } from './components/product-finder/advanced-search/advanced-search.component';
import { ProductListComponent } from './components/product-finder/product-list/product-list.component';

@NgModule({
  declarations: [QuotesComponent],
  imports: [
    CommonModule,
    PageTitle,
    I18nModule,
    FormModule,

    GeneralInformationsComponent,
    BasicSearchComponent,
    AdvancedSearchComponent,
    QuotationFormComponent,
    ProductListComponent,
    ProductFinderComponent,
  ],
  providers: [
    provideConfig(quotesOccContentConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        QuotesPageComponent: {
          component: QuotesComponent,
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          quotes: { paths: ['quotes/:query'] },
        },
      },
    }),
  ],
})
export class QuotesModule {}
